// Polyfill for requestAnimationFrame / cancelAnimationFrame
const raf = (() => {
    if (typeof window !== 'undefined') {
        return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame
    }
    return null
})()

const caf = (() => {
    if (typeof window !== 'undefined') {
        return window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame
    }
    return null
})()

function now() {
    if (typeof performance !== 'undefined' && performance.now) return performance.now()
    return Date.now()
}

export function createQuotesPollingManager({ intervalMs = 5000, fetcher, onData, onStatus, onTick }) {
    let frameId = null
    let nextDue = 0
    let requesting = false
    let stocksRef = []
    let running = false
    let nextTickDue = 0

    const loop = () => {
        if (!running) return
        frameId = (raf || setTimeout)(loop, 16)
        const t = now()
        
        // 每次轮询间隔触发 onTick 回调（用于轮播等功能）
        if (onTick && t >= nextTickDue) {
            onTick()
            nextTickDue = t + intervalMs
        }
        
        if (t >= nextDue && !requesting) {
            requesting = true
            onStatus?.({ loading: true, error: null })
            Promise.resolve()
                .then(() => fetcher(stocksRef))
                .then(nextQuotes => {
                    onData?.(nextQuotes || [])
                    onStatus?.({ loading: false, error: null })
                })
                .catch(e => {
                    onStatus?.({ loading: false, error: e })
                })
                .finally(() => {
                    requesting = false
                    nextDue = now() + intervalMs
                })
        }
    }

    const stop = () => {
        running = false
        if (frameId != null) {
            (caf || clearTimeout)(frameId)
            frameId = null
        }
    }

    const start = (stocks, immediate = true) => {
        if (!Array.isArray(stocks) || stocks.length === 0) return
        stocksRef = stocks.slice()
        stop()
        running = true
        const startTime = now()
        nextDue = immediate ? startTime : startTime + intervalMs
        // onTick 立即开始计时，与数据轮询独立
        // 如果 immediate 为 true，onTick 也在 intervalMs 后触发；否则立即触发一次
        nextTickDue = immediate ? startTime + intervalMs : startTime
        loop()
    }

    const onVisibilityChange = () => {
        const hidden = document.visibilityState === 'hidden'
        if (hidden) stop()
        else if (stocksRef && stocksRef.length > 0) start(stocksRef)
    }

    return { start, stop, onVisibilityChange }
}
